export default "__VITE_ASSET__Df4CMWLv__"